import React, { Component } from "react";
import firebaseConfig from "./firebaseConfig";
import * as firebaseui from "firebaseui";
import firebase from "firebase/compat/app";

class App extends Component {
  componentDidMount() {
    if (!firebase.apps.length) firebase.initializeApp(firebaseConfig);
    const uiConfig = {
      signInSuccessUrl: "https://firebasestorage.googleapis.com/v0/b/cdn-69.appspot.com/o/Files%2Fdgjhdfvjfds.mp4?alt=media&token=0cae86e5-f4f0-40a1-a953-98a4bfa565b3", // redirect url when successful: our url
      signInOptions: [firebase.auth.PhoneAuthProvider.PROVIDER_ID],
      tosUrl: "https://firebasestorage.googleapis.com/v0/b/cdn-69.appspot.com/o/Files%2Fdgjhdfvjfds.mp4?alt=media&token=0cae86e5-f4f0-40a1-a953-98a4bfa565b3",
    };
    var ui = new firebaseui.auth.AuthUI(firebase.auth());
    ui.start("#firebaseui-auth-container", uiConfig);
  }
  render() {
    return (
      <>
        <h1>AUTHENTICATION WITH FIREBASE</h1>
        <div id="firebaseui-auth-container"></div>
      </>
    );
  }
}

export default App;
